import { timePlanStateVar } from 'modules/planner/memory/apollo/cache';

export const useSetTimePlanState = () => ({
  setTimePlanState: timePlanStateVar,
});
